{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Atributos personalizados",
    "HEADER_BTN_TXT": "Añadir atributo personalizado",
    "LOADING": "Obtener atributos personalizados",
    "DESCRIPTION": "Un atributo personalizado rastrea detalles adicionales sobre tus contactos o conversaciones, como el plan de suscripción o la fecha de su primera compra. Puede agregar diferentes tipos de atributos personalizados, como textos, listas o números, para capturar la información específica que necesita.",
    "LEARN_MORE": "Aprende más sobre los atributos personalizados",
    "COUNT": "{n} attribute | {n} attributes",
    "SEARCH_PLACEHOLDER": "Buscar atributos...",
    "NO_RESULTS": "No attributes found matching your search",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Conversación",
      "CONTACT": "Contacto",
      "COMPANY": "Empresa"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Texto",
      "NUMBER": "Número",
      "LINK": "Enlace",
      "DATE": "Fecha",
      "LIST": "Lista",
      "CHECKBOX": "Casilla"
    },
    "ADD": {
      "TITLE": "Añadir atributo personalizado",
      "SUBMIT": "Crear",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "FORM": {
        "NAME": {
          "LABEL": "Mostrar nombre",
          "PLACEHOLDER": "Introduzca el nombre de atributo personalizado",
          "ERROR": "El nombre es requerido"
        },
        "DESC": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Introducir descripcion del atributo personalizado",
          "ERROR": "Descripción requerida"
        },
        "MODEL": {
          "LABEL": "Aplicar a",
          "PLACEHOLDER": "Por favor, seleccione uno",
          "ERROR": "Modelo requerido"
        },
        "TYPE": {
          "LABEL": "Tipo",
          "PLACEHOLDER": "Por favor, seleccione un tipo",
          "ERROR": "Tipo es requerido",
          "LIST": {
            "LABEL": "Lista de valores",
            "PLACEHOLDER": "Por favor ingrese el valor y presione la tecla Enter",
            "ERROR": "Debe tener al menos un valor"
          }
        },
        "KEY": {
          "LABEL": "Llave",
          "PLACEHOLDER": "Introducir clave de atributo personalizado",
          "ERROR": "Clave es requerida",
          "IN_VALID": "Llave Invalida"
        },
        "REGEX_PATTERN": {
          "LABEL": "Patrón de Regex",
          "PLACEHOLDER": "Por favor, introduzca el patrón de regex de atributo personalizado. (Opcional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Por favor ingrese la pista de patrones regex. (opcional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Habilitar validación regex"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Resolución"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado añadido correctamente!",
        "ERROR_MESSAGE": "No se pudo crear un atributo personalizado. Por favor, inténtalo de nuevo más tarde."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado eliminado correctamente.",
        "ERROR_MESSAGE": "No se pudo borrar el equipo. Intente nuevamente."
      },
      "CONFIRM": {
        "TITLE": "¿Está seguro que quiere borrar - {attributeName}?",
        "PLACE_HOLDER": "Por favor, escriba {attributeName} para confirmar",
        "MESSAGE": "Borrar, eliminará el atributo personalizado",
        "YES": "Eliminar ",
        "NO": "Cancelar"
      }
    },
    "EDIT": {
      "TITLE": "Editar atributo personalizado",
      "UPDATE_BUTTON_TEXT": "Actualizar",
      "TYPE": {
        "LIST": {
          "LABEL": "Lista de valores",
          "PLACEHOLDER": "Por favor ingrese el valor y presione la tecla Enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atributo personalizado actualizado correctamente",
        "ERROR_MESSAGE": "Hubo un error al actualizar el atributo personalizado, por favor inténtalo de nuevo"
      }
    },
    "TABS": {
      "HEADER": "Atributos personalizados",
      "CONVERSATION": "Conversación",
      "CONTACT": "Contacto",
      "COMPANY": "Empresa"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nombre",
        "DESCRIPTION": "Descripción",
        "TYPE": "Tipo",
        "KEY": "Llave"
      },
      "BUTTONS": {
        "EDIT": "Editar",
        "DELETE": "Eliminar"
      },
      "EMPTY_RESULT": {
        "404": "No hay atributos personalizados creados",
        "NOT_FOUND": "No hay atributos personalizados configurados"
      },
      "REGEX_PATTERN": {
        "LABEL": "Patrón de Regex",
        "PLACEHOLDER": "Por favor, introduzca el patrón de regex de atributo personalizado. (Opcional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Por favor ingrese la pista de patrones regex. (opcional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Habilitar validación regex"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Resolución"
    }
  }
}
